// import { BrowserRouter, useNavigate, useLocation } from "react-router-dom";
// import Layout from "./components/ui/layout/layout"; 
// import { AuthProvider } from "./context/AuthContext";
// import Router from './routes/index'
// import NotificationToast from './components/ui/ui/NotificationToast'
// import { useTelegram } from "./hooks/useTelegram";
// import { useAuth } from "./context/AuthContext";
// import { useEffect, useRef } from "react";
// import { ThemeProvider } from "./components/theme-provider";
// import { HelmetProvider } from "react-helmet-async";
// import AnimatedBackground from "./components/ui/AnimatedBackground"

// function AppContent() {
//   const { isTelegram, initData } = useTelegram();
//   const { user, loginWithTelegram } = useAuth();

//   const navigate = useNavigate();
//   const location = useLocation();
//   const loginAttempted = useRef(false);

//   // Scroll to top on route change
//   useEffect(() => {
//     window.scrollTo({
//       top: 0,
//       left: 0,
//       behavior: 'instant'
//     });
//   }, [location.pathname]);

//   // Debug: Log user state
//   useEffect(() => {
//     /*
//     if (isTelegram) {
//       console.log('Telegram User State:', { 
//         user: user ? { id: user.id, email: user.email, role: user.role } : null,
//         isTelegram,
//         initData: initData ? 'present' : 'missing'
//       });
//     }
//     */
//   }, [user, isTelegram, initData]);

//   // Auto-login Telegram users (only once)
//   useEffect(() => {
//     const autoLogin = async () => {
//       if (isTelegram && initData && !user && !loginAttempted.current) {
//         loginAttempted.current = true;
//         try {
//           await loginWithTelegram(initData);
//           // After successful login, check for deep link
//           const deepLink = sessionStorage.getItem('telegram_deep_link');
//           if (deepLink) {
//             navigate(deepLink, { replace: true });
//             sessionStorage.removeItem('telegram_deep_link');
//           }
//         } catch (error) {
//           console.error('Auto-login failed:', error);
//           loginAttempted.current = false; // Allow retry on error
//         }
//       }
//     };
//     autoLogin();
//   }, [isTelegram, initData, user, loginWithTelegram, navigate]);

//   // Handle Deep Linking - only process once
//   useEffect(() => {
//     if (isTelegram) {
//       const startParam = window.Telegram?.WebApp?.initDataUnsafe?.start_param;
//       const deepLinkHandled = sessionStorage.getItem('deep_link_handled');
      
//       if (startParam && startParam.startsWith('job_') && !deepLinkHandled) {
//         const jobId = startParam.split('_')[1];
//         if (jobId) {
//           // Mark as handled so we don't redirect again
//           sessionStorage.setItem('deep_link_handled', 'true');
          
//           // Store the intended destination
//           sessionStorage.setItem('telegram_deep_link', `/jobs/${jobId}`);
          
//           // If user is already logged in, navigate immediately
//           if (user) {
//             navigate(`/jobs/${jobId}`);
//             sessionStorage.removeItem('telegram_deep_link');
//           }
//           // Otherwise, auto-login will handle it
//         }
//       }
//     }
//   }, [isTelegram, user, navigate]);

//   // After login, check for stored deep link
//   useEffect(() => {
//     if (user && isTelegram) {
//       const deepLink = sessionStorage.getItem('telegram_deep_link');
//       if (deepLink) {
//         navigate(deepLink, { replace: true });
//         sessionStorage.removeItem('telegram_deep_link');
//       }
//     }
//   }, [user, isTelegram, navigate]);

//   return (
//     <div className="min-h-screen">
//       <AnimatedBackground/>
//       <Layout>
//         <Router />
//       </Layout>
//       <NotificationToast />
//     </div>
//   );
// }

// function App() {
//   return (
//     <HelmetProvider>
//       <BrowserRouter>
//         <AuthProvider>
//           <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
//             <AppContent />
//           </ThemeProvider>
//         </AuthProvider>
//       </BrowserRouter>
//     </HelmetProvider>
//   );
// }

// export default App;

import { BrowserRouter, useNavigate, useLocation } from "react-router-dom";
import Layout from "./components/ui/layout/layout"; 
import { AuthProvider } from "./context/AuthContext";
import Router from './routes/index'
import NotificationToast from './components/ui/ui/NotificationToast'
import { useTelegram } from "./hooks/useTelegram";
import { useAuth } from "./context/AuthContext";
import { useEffect, useRef } from "react";
import { ThemeProvider } from "./components/theme-provider";
import { HelmetProvider } from "react-helmet-async";
import AnimatedBackground from "./components/ui/AnimatedBackground"

function AppContent() {
  const { isTelegram, initData } = useTelegram();
  const { user, loginWithTelegram } = useAuth();

  const navigate = useNavigate();
  const location = useLocation();
  const loginAttempted = useRef(false);

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }, [location.pathname]);

  // Auto-login Telegram users (only once)
  useEffect(() => {
    const autoLogin = async () => {
      if (isTelegram && initData && !user && !loginAttempted.current) {
        loginAttempted.current = true;
        try {
          await loginWithTelegram(initData);
          // After successful login, check for deep link
          const deepLink = sessionStorage.getItem('telegram_deep_link');
          if (deepLink) {
            navigate(deepLink, { replace: true });
            sessionStorage.removeItem('telegram_deep_link');
          }
        } catch (error) {
          console.error('Auto-login failed:', error);
          loginAttempted.current = false;
        }
      }
    };
    autoLogin();
  }, [isTelegram, initData, user, loginWithTelegram, navigate]);

  // Handle Deep Linking - only process once
  useEffect(() => {
    if (isTelegram) {
      const startParam = window.Telegram?.WebApp?.initDataUnsafe?.start_param;
      const deepLinkHandled = sessionStorage.getItem('deep_link_handled');
      
      if (startParam && startParam.startsWith('job_') && !deepLinkHandled) {
        const jobId = startParam.split('_')[1];
        if (jobId) {
          sessionStorage.setItem('deep_link_handled', 'true');
          sessionStorage.setItem('telegram_deep_link', `/jobs/${jobId}`);
          
          if (user) {
            navigate(`/jobs/${jobId}`);
            sessionStorage.removeItem('telegram_deep_link');
          }
        }
      }
    }
  }, [isTelegram, user, navigate]);

  // After login, check for stored deep link
  useEffect(() => {
    if (user && isTelegram) {
      const deepLink = sessionStorage.getItem('telegram_deep_link');
      if (deepLink) {
        navigate(deepLink, { replace: true });
        sessionStorage.removeItem('telegram_deep_link');
      }
    }
  }, [user, isTelegram, navigate]);

  return (
    <div className="min-h-screen relative">
      {/* Animated Background - placed at the very back */}
      <AnimatedBackground />
      
      {/* Content container with proper z-index */}
      <div className="relative z-10">
        <Layout>
          <Router />
        </Layout>
      </div>
      
      <NotificationToast />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
            <AppContent />
          </ThemeProvider>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;